import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Positions from './Positions';
import Content from './Content';
import ApplySection from './ApplySection';
import JobsPage from './JobsPage';
const router = createBrowserRouter([
  {
    path: "/",
    // element: <App />,
    element:<Content />
  },
  {
    path: "/app",
    element: <App />,
    // element:<Content />
  },
  {
    path: "/open-positions",
    element: <JobsPage />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <RouterProvider router={router} />
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
